'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const createMessage = message => ({
  options
}) => /*#__PURE__*/_jsx(FormattedMessage, {
  message: message,
  options: options
});